module.exports = __webpack_public_path__ + "img/蒙版组 1@2x (2)_副本.fd8ae75b.webp";